module.exports = __webpack_public_path__ + "static/img/200155.dab7510f.png";